import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'atw-map-repeat-config',
  templateUrl: './map-repeat-config.component.html',
  styleUrls: ['./map-repeat-config.component.scss']
})
export class AtwMapRepeatConfig implements OnInit {
  @Input() device: any; // xác định thiết bi mobile, desktop ,....
  @Input() visibleConfigMap: boolean = false;
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() objectChoosing: any = {}; // xác định object frame đang được chọn
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  isCollapsed: boolean = false; // biến check hiển thị đóng mở menu config
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'dieu_chinh_bo_goc',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  isViewAll: boolean = false;
  radioValue = ''; //Biến này dùng để phân biệt kiểu bản đồ người dùng muốn add

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator, 
  ) { }

  ngOnInit(): void {
  }

  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id,
      { [this.device + '_class']: this.class })
      .then((bool: any) => {
      })
  }
 
  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }

  /**
   * Hàm mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = { menu1: true, menu2: false, menu3: false };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['map']['width'] = event.width + 'px';
    if (event.height) this.class['map']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
